import { createSelector } from '@reduxjs/toolkit';
import selectAxon from './selectAxon';
import selectCalls from './selectCalls';
import selectGisSearch from './selectGisSearch';

// Allows the user of @rsos/lib to opt into the datasets they want to search.
// To add new datasets, add a new key to this object and a new selector below.
const mapDatasetToSelectors = {
  axon: selectAxon,
  calls: selectCalls,
  gis_search: selectGisSearch,
};

/**
 * Creates a selector that returns an array of searchable datasets.
 * NOTE: This should always be a plain function that works via input arguments.
 * In other words, shouldn't be connected directly to redux because it will
 * create a hard dependency on the redux store and make it difficult to test.
 * @param {*} datasetNames - The name of the datasets to select.
 */
const createDatasetsSelector = (datasetNames = []) => {
  const selectors = datasetNames.map(
    selector => mapDatasetToSelectors[selector],
  );
  return createSelector(...selectors, (...datasets) =>
    datasets.filter(Boolean),
  );
};

export default createDatasetsSelector;
